import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { getPreferredOrientationAdjustmentAngle, useScreenOrientation, } from '../utils';
export function Hud({ orientation, visible = false, ...props }) {
    const screenOrientation = useScreenOrientation();
    const angle = getPreferredOrientationAdjustmentAngle(orientation, screenOrientation);
    return _jsx(HudRoot, { ...props, "$angle": angle, "$visible": visible });
}
const HudRoot = styled.div `
    --Hud_Rotation: ${({ $angle }) => `${$angle}deg`};
    --Hud_Height: var(--vh-100, 100vh);
    --Hud_Width: var(--vw-100, 100vw);

    ${({ $angle }) => $angle % 180 !== 0 &&
    css `
            --Hud_Height: var(--vw-100, 100vw);
            --Hud_Width: var(--vh-100, 100vh);
        `}

    position: fixed;
    height: var(--Hud_Height);
    width: var(--Hud_Width);
    transform: translate(-50%, -50%)
        translate(calc(var(--vw, 1vw) * 50), calc(var(--vh, 1vh) * 50))
        rotate(var(--Hud_Rotation, 0deg));
    transform-origin: center;
    opacity: 0;
    visibility: hidden;
    transition: 300ms;
    transition-property: visibility, opacity;
    transition-delay: 300ms, 0s;

    ${({ $visible }) => $visible &&
    css `
            opacity: 1;
            visibility: visible;
            transition-delay: 0s;
        `}
`;
